import { useNavigate } from "react-router-dom";
import { Customer } from "types";
import { Routes } from "routes";

export const useCustomerRoutes = () => {
  const navigate = useNavigate();

  const CustomerIcon = Routes.customers.icon;

  const getCustomerPageRoute = (customer: Customer) =>
    Routes.customers.subNavigations.customer.path.replace(
      ":customerID",
      customer.id,
    );

  const getCustomerListPageRoute = () => Routes.customers.path;

  const navigateToCustomerPage = (customer: Customer) => {
    navigate(getCustomerPageRoute(customer));
  };

  const navigateToCustomerListPage = () => {
    const searchParams = sessionStorage.getItem(getCustomerListPageRoute());

    navigate(
      searchParams
        ? getCustomerListPageRoute() + "?" + searchParams
        : getCustomerListPageRoute(),
    );
  };

  return {
    CustomerIcon,
    getCustomerPageRoute,
    navigateToCustomerPage,
    navigateToCustomerListPage,
  };
};
